<template>
    <form @submit.prevent.stop="submitHandler" class="lg:flex">
        <div class="tra__message-form relative lg:w-2/3 lg:pr-3">
          <div class="grid grid-cols-6 gap-6">
              <div class="col-span-12 lg:col-span-3 mb-3">
                <label for="form-name" class="block text-base font-semibold text-gray-700">Autoresponder Name
                  <span class="text-red-500">*</span></label>
                <input type="text" v-model="form.autoresponderName" name="form-name" id="form-name" autocomplete="off" required
                  class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md" />
                  <p v-if="form.errors.autoresponderName" class="text-red-500 text-sm mt-1">
                      {{ form.errors.autoresponderName }}
                    </p>
              </div>
          </div>
            <div v-if="!autoresponder" class="lg:flex justify-stretch">
                <div class="mt-3 md:w-64 md:flex-grow lg:pl-0">
                  <label for="autoresponder-type" class="block text-base font-semibold text-gray-700">
                    Autoresponder type
                  </label>
                    <button-select
                        v-model="form.autoResponderType"
                        :options="{ keyword: 'Keyword', triggerword: 'Trigger Word', global: 'Global' }"
                        :default="form.autoResponderType"
                        button-style="buttonGroup"
                        @resetValue="resetValues"

                    />
                </div>
            </div>
            <div class="-mx-4 sm:mx-0 mt-4">
                <div v-if="form.autoResponderType === 'keyword'">
                  <p class="bold mb-4 md:mr-4">An automatic message sent after someone opts-in to one of your keywords.</p>
                    <label for="Keyword" class="block text-base font-semibold text-gray-700">
                      Keyword
                    </label>
                    <multiselect
                      v-model="keyword"
                      :options="keywordOptions"
                      type="select"
                      @change="updateDefaultMessage()"
                      label="label"
                      select-label=""
                      deselect-label=""

                    />
                    <p v-if="form.errors.keyword_id" class="text-red-500 text-sm mt-1">
                      {{ form.errors.keyword_id }}
                    </p>
                </div>
                <div class="mt-3 lg:pl-0" v-if="form.autoResponderType === 'global'">
                    <p class="bold mb-4 md:mr-4">An automatic message sent after someone texts your phone number (i.e. an after hours message).</p>
                      <!-- <button-select
                        :options="{ week: 'Immediately'}"
                        default="week"
                        button-style="buttonGroup"
                      /> -->
                </div>
                <div class="md:block" v-if="form.autoResponderType === 'triggerword'">
                  <p class="bold mb-4 md:mr-4 w-full">An automatic message sent after someone texts a specific word to your phone number (not list dependent).</p>
                  <div class="md:w-1/2 md:pr-2 mb-2 md:mb-0">
                    <label for="trigger-word" class="block text-base font-semibold text-gray-700">
                      Trigger Word
                      <span class="text-red-500">*</span>
                    </label>
                    <input v-model="form.triggerword" type="text" name="trigger-word" id="trigger-word" autocomplete="off" required
                      class="uppercase mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md" />
                    <p v-if="form.errors.triggerword" class="text-red-500 text-sm mt-1">
                      {{ form.errors.triggerword }}
                    </p>
                  </div>
                </div>
                <autoresponder-form-global
                    v-if="form.autoResponderType === 'global'"
                    v-model="recurringFormData"
                    :send_type="send_type"
                />
              <p v-if="form.errors.scheduled_send_days && form.autoResponderType === 'global'" class="text-red-500 text-sm mt-1">
                {{ form.errors.scheduled_send_days }}
              </p>
              <p v-else-if="form.errors.end_time && form.autoResponderType === 'global'" class="text-red-500 text-sm mt-1">
                {{ form.errors.end_time }}
              </p>
            </div>
            <div class="w-full mt-4 mb-4">
                <MessageFormEditor
                    v-model="editorFields"
                    :error="errors.unparsed_message ? errors.unparsed_message : null"
                    @image-preview="data => imagePreview = data"
                />
                <p v-if="form.errors.unparsed_message" class="text-red-500 text-sm mt-1">
                  {{ form.errors.unparsed_message }}
                </p>
            </div>
            <div class="flex justify-between p-2 md:p-8 items-center bg-gray-100 rounded-lg">
                <div>
                    <template v-if="autresponderSelected || creditCount > 0">
                        Your autoresponder will use <span class='font-bold text-gray-700'>{{ creditCount }} {{ creditCount == 1 ? 'credit' : 'credits' }}</span> per message.
                    </template>
                    <template v-else>
                        Select a Keyword and type a message to get started!
                    </template>
                </div>

                <div class="">
                  <Link class="mr-4" :href="route('autoresponder.index')">
                      Cancel
                  </Link>

                    <jet-button
                        :disabled="!autresponderSelected"
                        :loading="loading"
                    >
                        {{ sendButtonText }}
                    </jet-button>
                </div>
            </div>
        </div>
        <div class="lg:border-t-0 border-t border-t-1 border-t-gray-200 lg:w-1/3 lg:pl-3 pt-6 lg:pt-0 mt-6 lg:mt-0 flex">
            <MessageFormPreview
                :message="editorFields.message"
                :media="imagePreview"
                :isKeyword = "form.autoResponderType === 'keyword'"
                :groupTitle = "keyword?.group_title"
            />
        </div>

    </form>
</template>

<script>
import JetDialogModal from '../Jetstream/DialogModal';
//import DatePicker from "vue2-datepicker";
//import "vue2-datepicker/index.css";

import JetButton from "../Jetstream/Button";
import axios from "axios";

import JetSecondaryButton from '../Jetstream/SecondaryButton';
import ContactSelect from './ContactSelect';
import MessageFormRecurring from './AutoresponderForm/AutoresponderFormGlobal';
// import MessageFormLater from './AutoresponderForm/AutoresponderFormTrigger';
import MessageFormEditor from './AutoresponderForm/MessageFormEditor.vue';
import MessageFormPreview from './AutoresponderForm/MessageFormPreview.vue';
import ButtonSelect from './ButtonSelect';

import { SegmentedMessage } from 'sms-segments-calculator';
import AutoresponderFormGlobal from './AutoresponderForm/AutoresponderFormGlobal';


export default {
    components: {
       // DatePicker,
        AutoresponderFormGlobal,
        JetButton,
        JetDialogModal,
        JetSecondaryButton,
        ContactSelect,
        MessageFormEditor,
        MessageFormRecurring,
        // MessageFormLater,
        MessageFormPreview,
        ButtonSelect,
    },
    props: {
      autoresponder:  Object
    },
    emits: ['success'],
    mounted() {
        if (this.autoresponder) {
          this.send_type = this.autoresponder.type;
          this.form.autoResponderType = this.autoresponder.type;
          this.form.autoresponderName = this.autoresponder.title;
          this.form.keyword_id = this.autoresponder.keyword_id;
          this.form.triggerword = this.autoresponder.trigger_word;
          this.editorFields.message = this.autoresponder.message;
          this.editorFields.media = this.autoresponder.media;
          this.recurringFormData.repeats_on = this.autoresponder.scheduled_days;
          this.imagePreview = this.autoresponder.media
          this.recurringFormData.start_time = this.autoresponder.start_time;
          this.recurringFormData.end_time = this.autoresponder.end_time;
          if (this.form.keyword_id) {
            this.keyword = this.keywordOptions.find(keyword => keyword.value == this.form.keyword_id)
            this.updateDefaultMessage()
          }
        }
        this.current_date = new Date();
        this.current_date.setHours(0, 0, 0, 0);

        // Set the default end date to six months in the future
        this.end_date = new Date().setMonth(this.current_date.getMonth() + 6);
    },
    data() {
        return {
            form: this.$inertia.form({
                autoresponderId: null,
                autoresponderName: null,
                keyword_id: null,
                triggerword: null,
                group_id: undefined,
                unparsed_message: null,
                send_time: null,
                media: null,
                scheduled_send_days: null,
                scheduled_send_time_delay: null,
                autoResponderType: "keyword",
                start_time: null,
                end_time: null
            }, {
                resetOnSuccess: true,
            }),
            keyword: null,
            uploadImageFormVisible: false,
            group: null,
            send_date: null,
            send_hour: "12",
            send_min: "00",
            send_period: "AM",
            send_type: "keyword",
            recurringFormData: {
              repeats_on: [],
              delay: null,
              errors: null,
              start_time: null,
              end_time: null,
            },
            phone_number: null,
            current_date: "",
            messageable_type: "immediately",
            errors: {
                unparsed_message: null,
            },
            segment_lengths: {
                sms_ucs: 70,
                sms_gsm: 160,
                mms_ucs: 1000,
                mms_gsm: 1600
            },
            sms_segment_credit: 1,
            mms_segment_credit: 3,
            messageHeldForReviewIsOpen: false,
            creditOverageModal: false,
            imagePreview: null,
            creditLimitData: null,
            editorFields: {
                message: "",
                media: null
            },
        };
    },
    created() {
        let params = new URLSearchParams(document.location.search);
        if (params.has("list_id")) {
        this.selectedOption = "group";
        }
    },
  computed: {
        loading () {
            return this.form.processing;
        },
        keywords() {
            return this.$page.props.keywords;
        },
        keywordOptions() {
            return this.keywords.map(keyword => {
                return {
                    value: keyword.id,
                    label: keyword.keyword,
                    group_title: keyword.group_title,
                };
            });
        },
        sendButtonText() {
            if (this.loading) {
                return "Processing...";
            }
            return "SAVE AUTORESPONDER";
        },
        sendTime() {
            if (this.send_type === "now") {
                return null; // sending null will create a current timestamp once submitted to the backend
            }

            // @todo - add null handling here if the date hasn't been set yet
            if (this.send_type === "later") {
                let hour = this.send_hour === "12" ? "00" : this.send_hour;

                if (this.send_period === "PM") {
                    hour = parseInt(hour, 10) + 12;
                }

                return `${this.send_date} ${hour}:${this.send_min}`;
            }
        },
        messageSegments() {
            return new SegmentedMessage(this.editorFields.message);
        },
        characterCount() {
            return this.editorFields.message.length;
        },
        autresponderSelected() {
          if (this.form.keyword_id != null) {
            return true
          } else if (this.form.triggerword != null) {
            return true
          } else if (this.recurringFormData.repeats_on.length) {
            return true
          }
          return false
        },
        /*
        Estimated number of credits to be used by the message
         */
        creditCount() {
            if (this.editorFields.media && !_.isEmpty(this.editorFields.media)) {
                // divide character count by segment length and round up
                // to nearest integer to get number of segments, and then
                // we multiply that by the number of credits per segment to
                // get total estimated credit cost
                if ( this.messageSegments.encodingName === 'GSM-7' && this.characterCount ) {
                    return Math.ceil(this.characterCount / this.segment_lengths.mms_gsm) * this.mms_segment_credit * 1;
                }

                if ( this.messageSegments.encodingName === 'UCS-2' && this.characterCount ) {
                    return Math.ceil(this.characterCount / this.segment_lengths.mms_ucs) * this.mms_segment_credit * 1;
                }

                if ( !this.characterCount) {
                  return this.mms_segment_credit;
                }
            } else {
                return this.messageSegments.segmentsCount;
            }
        },
    },
    methods: {
      async updateDefaultMessage() {
        if (this.form.keyword_id) {
          let keywordGroupResponse = await axios.get(`/api/keyword/${this.form.keyword_id}/group-title`);
          this.selectedKeywordGroup = keywordGroupResponse.data
        }
      },
        messageableClass(messageable_type) {
            return this.messageable_type === messageable_type
                ? "bg-blue-400 text-blue-100 border-blue-400 border"
                : "bg-blue-100 text-blue-400 border-blue-400 border";
        },
        errorMessage(error) {
            this.errors = error;
            let errorMessage = "Uh oh! Something went wrong.";

            if (error.message == 'held_for_review' ) {
                this.messageHeldForReviewIsOpen = true;
                return;
            }

            if ( error.message ) {
              errorMessage = error.display_message;
            }

            this.$toasted.show(errorMessage, {
                position: "bottom-right",
                type: "error",
                duration: 3000
            });
        },
        resetValues() {
            this.editorFields.message = "";
            this.form.unparsed_message = null;
            this.form.keyword_id = null;
            this.form.triggerword = "";
            this.errors = {};
        },
        closeMessageHeldForReviewModal() {
            this.messageHeldForReviewIsOpen = false;
            this.resetValues();
        },
        closeOverageModal() {
            this.creditOverageModal = false;
        },
        async submitHandler() {
            console.log("submitting form");
            console.log(this.form);
            this.form.transform((data) => ({
              ...data,
              sendType: this.send_type,
              autoresponderId : this.autoresponder ? this.autoresponder.id : null
            }))
            .post(route("autoresponder.store"), {
                onSuccess: () => {
                    this.resetValues();
                    const type = this.autoresponder ? 'updated' : (this.send_type === "global" ? "scheduled" : "created");
                    this.$toasted.show(`Your autoresponder has been successfully ${type}!`, {
                        position: "bottom-right",
                        type: "success",
                        duration: 3000
                    });
                    if (type == 'created') {
                        this.$inertia.visit(route('autoresponder.index'));
                    }
                    this.$emit('success');
                },
                onError: error => {
                    console.log(error)
                    this.errorMessage(error);
                }
            });

        }
    },
    watch: {
        editorFields: {
            handler(value) {
                this.form.unparsed_message = value.message;
                this.form.media = value.media;
            },
            deep: true
        },
        messageable_type(value) {
        },
        sendTime(value) {
            this.form.send_time = value;
        },
        recurringFormData: {
            handler(value) {
                this.form.scheduled_send_days = value.repeats_on;
                this.form.scheduled_send_time_delay = value.delay;
                this.form.start_time = value.start_time;
                this.form.end_time = value.end_time;
            },
            deep: true
        },
        form: {
          handler(value)  {
            this.recurringFormData.errors = value.errors ? value.errors.scheduled_send_days : null;
          },
          deep: true
        },
        keyword: {
            handler(keyword) {
                this.form.keyword_id = keyword.value;
            },
            deep: true
        },
    }
};
</script>

<style>
.toasted.success {
    @apply bg-green-500 text-white font-bold shadow rounded !important;
}

.toasted.error {
    @apply bg-red-500 text-white font-bold shadow rounded !important;
}

select {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%2371717a' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E");
    background-position: right 0.5rem center;
    background-repeat: no-repeat;
    background-size: 1.5em 1.5em;
    padding-right: 2.5rem;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.occurrences input {
    @apply w-1/3;

    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.vs__dropdown-toggle {
    height: 42px;
}

.triangle {
    position: absolute;
    bottom: -33px;
    height: 25px;
    width: 40px;
    background: #ebf8ff;
    z-index: 1;
    display: block;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    pointer-events: none;
}

</style>
